import { BAOCustomElement } from '@bao/custom-element'
import { eventBus, EVENTS } from '@bao/events'
import { getElement } from '@bao/utils'

class CollectionBannersSubLink extends BAOCustomElement() {
  static get requiredElements () {
    return ['link']
  }

  checkValidity () {
    super.checkValidity()

    if (!this.filters) {
      this.throwError('collection-filters must be present on the page')
    }
  }

  connectedCallback () {
    super.connectedCallback()

    this.scroll = false

    this.updateActiveState()
  }

  setupListeners () {
    super.setupListeners()

    this.els.link?.elements.forEach((linkEl) => {
      this.listeners.add(linkEl, 'click', (event) => {
        event.preventDefault()
        this.filters.onLinkClick(event)
        this.scroll = true
      })
    })

    eventBus.addEventListener(
      EVENTS.COLLECTION.UPDATE,
      this.onCollectionUpdate.bind(this),
    )
  }

  updateActiveState (event) {
    const params = event?.detail?.searchParams || location.search
    const searchParams = new URLSearchParams(params)
    if (!searchParams) return

    this.els.link?.elements.forEach((linkEl) => {
      const filter = decodeURIComponent(linkEl.search)
      const namespace = filter.split('=')[0]?.replace('?', '')
      const value = filter.split('=')[1]

      if (
        searchParams.has(namespace) &&
        searchParams.get(namespace) === value
      ) {
        linkEl.setAttribute('aria-current', '')
      } else {
        linkEl.removeAttribute('aria-current')
      }
    })
  }

  onCollectionUpdate (event) {
    this.updateActiveState(event)

    /* Scroll to grid */
    if (this.scroll) {
      const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)',
      ).matches

      this.filters.scrollIntoView({
        behavior: prefersReducedMotion ? 'instant' : 'smooth',
        block: 'start',
        inline: 'start',
      })
    }

    this.scroll = false
  }

  /**
   * @returns {CollectionFilters|null}
   */
  get filters () {
    return getElement('collection-filters')
  }
}

if (!customElements.get('collection-banner-sub-links')) {
  customElements.define(
    'collection-banner-sub-links',
    CollectionBannersSubLink,
  )
}
